import { createStore } from 'vuex'

const USER_INFO = 'USER_INFO';
const ROOT_MENU = 'ROOT_MENU';

export default createStore({
  state: {
    userInfo: window.SessionStorage.get(USER_INFO) || {},
    rootMenu: window.SessionStorage.get(ROOT_MENU) || '1050',
  },
  getters: {
  },
  mutations: {
    setUserInfo (state, _userInfo) {
      state.userInfo = _userInfo;
      window.SessionStorage.set(USER_INFO, _userInfo);
    },
    setRootMenu (state, _rootMenu) {
      state.rootMenu = _rootMenu;
      window.SessionStorage.set(ROOT_MENU, _rootMenu);
    }
  },
  actions: {
  },
  modules: {
  }
})
